<template>
    <div>
        <SelectMyDocument ref='SelectMyDocument'  @SelectMyDocument='SelectMyDocument'></SelectMyDocument>
    </div>
</template>
<script>
import SelectMyDocument from '../views/onlineEditing/components/SelectMyDocument.vue'
export default {
    components: {
        SelectMyDocument
    },
    data(){
        return {
            type:'file',
            model:'checkbox'
        }
    },
    mounted(){
        this.type = this.getUrlParam(window.location.href,"type");
        this.model = this.getUrlParam(window.location.href,'model') ? this.getUrlParam(window.location.href,'model') : 'checkbox';
        this.$refs.SelectMyDocument.show(this.type,null,this.model);
    },
    methods:{
        // 获取地址栏参数信息
        getUrlParam (sUrl, sKey){
            var resObj = {};
            var reg = /(\w+)=(\w+)/g;
            while (reg.exec(sUrl)) {
                resObj[RegExp.$1] ? resObj[RegExp.$1] = [].concat(resObj[RegExp.$1], RegExp.$2) : resObj[RegExp.$1] = RegExp.$2;
            }
            if (sKey) {
                return (resObj[sKey] ? resObj[sKey] : '');
            }
            return resObj;
        },

        SelectMyDocument(id,files){
            if(id == null && files == null){
                window.parent.postMessage({
                    'close':true,
                },'*')
            }else{
                if(this.type == 'file' && files.length != 0){
                    window.parent.postMessage({
                        'files':files
                    },'*')
                }else if(this.type == 'folder'){
                    window.parent.postMessage({
                        'folderId':id,
                    },'*')
                }
            }
           
           
        }
    }
}
</script>